import mixins from 'vue-typed-mixins';

import 差異分析Mixin from '@/entries/user/mixins/差異分析Mixin';
import { PlbscfInputableTextId } from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';

export default mixins(差異分析Mixin).extend({
  name: 'C差異分析貸借対照表',

  computed: {
    map(): PlbscfInputableTextId[][] {
      return this.createMapBy月次推移List(this.差異分析.bs.月次推移.list);
    },
  },

  watch: {
    keystrokeResetCount: {
      handler(): void {
        this.setFirstId();
      },
      immediate: true,
    },
  },
});
